import { CSOptionItem } from "../../types";
import React from "react";

type CheckboxGroupOption = CSOptionItem<string>;

type CheckboxGroupProps = {
  options: CheckboxGroupOption[];
  selectedOptions: string[];
  onChange: (selectedOptions: string[]) => void;
  ariaLabel: string;
};

/**
 * Renders a button group that acts as a checkbox group.
 * This is a controlled component so you need to pass in the selected options and an onChange handler.
 */
const CheckboxGroup = ({
  options,
  selectedOptions,
  onChange,
  ariaLabel,
}: CheckboxGroupProps) => {
  const handleCheckboxChange = (option: string) => {
    const updatedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((selectedOption) => selectedOption !== option)
      : [...selectedOptions, option];

    onChange(updatedOptions);
  };

  return (
    <fieldset className="btn-group btn-group-sm" aria-label={ariaLabel}>
      {options.map((option) => (
        <React.Fragment key={option.id}>
          <input
            type="checkbox"
            className="btn-check"
            value={option.id}
            id={option.id}
            checked={selectedOptions.includes(option.id)}
            onChange={() => handleCheckboxChange(option.id)}
          />
          <label className="btn btn-outline-primary" htmlFor={option.id}>
            {option.label}
          </label>
        </React.Fragment>
      ))}
    </fieldset>
  );
};

export default CheckboxGroup;
